// extracted by mini-css-extract-plugin
export default {"discussionLink":"ConvertedToDiscussionEvent-module__discussionLink__nqsRFUN"};